import ActionTypes from "../../../constants/ActionTypes";
import { IFetchDebugInfo, ISetDebugInfo } from "./types";

export function fetchDebugInfo(query?: any): IFetchDebugInfo {
  return {
    type: ActionTypes.DEBUG.GET_DEBUG_INFO,
  };
}

export function setDebugInfo(data: any): ISetDebugInfo {
  return {
    type: ActionTypes.DEBUG.SET_DEBUG_INFO,
    payload: data
  };
}

export function setMockResponse(mock: boolean): ISetDebugInfo {
  return {
    type: ActionTypes.DEBUG.SET_MOCK_RESPONSE,
    payload: mock
  };
}

